var parameterInsert={  
    IdDocQuestionsCategory:'',
    Question:'', 
    Description:'',
    Type:'0', 
    Active:'1',
    User:'',
    IP:''
} 
var parameterUpdate={
    IdDocQuestion:'',
    IdDocQuestionsCategory:'', 
    Question:'',  
    Description:'',
    Type:'0',
    Active:'1',
    User:'',
    IP:''
} 
var parameterView={  
    IdDocQuestionsCategory:'0',
    Name:'',  
    Category:'',
    QuestionCategory:'',
    Active:'2'
} 
export default
{
    parameterInsert,
    parameterUpdate,
    parameterView
}